module.exports = __webpack_public_path__ + "img/down-arrow.a851d75e.svg";